/**
 * ...
 * @author DefaultUser (Tools -> Custom Arguments...)
 */
/**
 * package: com.inq.utils
 * class: Capabilities
 * root Object
 * @constructor
 */
com.inq.utils.Capabilities = function() {
};
$hxClasses['com.inq.utils.Capabilities'] = com.inq.utils.Capabilities;
/** @private @type {Array} */
com.inq.utils.Capabilities.__name__ = ["com","inq","utils","Capabilities"];
/** @type {string} */
com.inq.utils.Capabilities.os = null;
/** @private @type {string} */
com.inq.utils.Capabilities._os = null;
/** @private @type {string} */
com.inq.utils.Capabilities.userAgent = null;
/** @type {boolean} */
com.inq.utils.Capabilities.isWebKit = null;
/** @type {null} */
com.inq.utils.Capabilities.viewportDetector = null;

/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.utils.Capabilities.init = function() {
	/** @type {?string} */
	var platform = null;
	/** @type {?string} */
	var cpuClass = null;
	/** @type {?string} */
	var replaceWith = null;
	/** @type {?EReg} */
	var pattern = null;
	try {
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = com.inq.utils.Capabilities.patternTable.length;
		while(_g1 < _g) {
			var /** @type {number} */ i = _g1++;
			pattern = new EReg(com.inq.utils.Capabilities.patternTable[i],"i");
			replaceWith = "$1";
			/** @type {boolean} */
			var b = pattern.match(com.inq.utils.Capabilities.getUserAgent());
			if (b) {
				/* 	pattern.replace(userAgent, replaceWith) ; */
				com.inq.utils.Capabilities._os = pattern.matched(1);
				switch(com.inq.utils.Capabilities._os) {
					case "Windows NT 6.1":
						com.inq.utils.Capabilities._os = "Windows 7/Windows Server 2008 R2";
						break;
					case "Windows NT 6.0":
						com.inq.utils.Capabilities._os = "Windows Vista/Windows Server 2008";
						break;
					case "Windows NT 5.2":
						com.inq.utils.Capabilities._os = "Windows XP/Windows Server 2003/Windows Home Server";
						break;
					case "Windows NT 5.1":
						com.inq.utils.Capabilities._os = "Windows XP";
						break;
					case "Windows NT 6.2":
						com.inq.utils.Capabilities._os = "Windows 8";
						break;
					case "Windows NT 10.0":
						com.inq.utils.Capabilities._os = "Windows 10";
						break;
					default:
						if (com.inq.utils.Capabilities._os.indexOf("like Mac OS X") != -1) {
							/** @type {string} */
							var sysVer = "";
							/** @type {string} */
							var device = "";
							/** @type {EReg} */
							var regExSysVer = new EReg("CPU OS (\\w*) like Mac OS X", "gi");
							/** @type {EReg} */
							var regDevice = new EReg("[\\s]*\\w+[/ ][0-9a-zA-Z.]*\\s[(](\\w+);\\s*([^;\\)]*).*", "gi");
							if (regExSysVer.match(com.inq.utils.Capabilities._os)) {
								sysVer = regExSysVer.matched(1);
							}
							if (regDevice.match(com.inq.utils.Capabilities.getUserAgent())) {
								device = " " + regDevice.matched(1);
							}
						com.inq.utils.Capabilities._os = "Mac iOS " + sysVer + device;
					}/* CPU OS 5_0 like Mac OS X */
				}
				return true;
			}
		}
	} catch (e) {
		if (js.Boot.__instanceof(e, Error)) {
		} else throw(e);
	}
	/* 	return userAgent.replace(pattern, replaceWith) ; */


	try {
		platform = window.navigator.platform;
		cpuClass = window.navigator.cpuClass;
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}

	com.inq.utils.Capabilities._os = null == platform?"unknown":platform;
	if(null != cpuClass) com.inq.utils.Capabilities._os += " " + cpuClass;
	return true;
};


/**
 * _getOS
 *
 * $type TFun([],TInst(String,[]))
 * private static function _getOS():String
 * @private
 * @static
 * @return {string}
 */
com.inq.utils.Capabilities._getOS = function() {
	if(com.inq.utils.Capabilities._init == false) com.inq.utils.Capabilities._init = com.inq.utils.Capabilities.init();
	return com.inq.utils.Capabilities._os;
};


/**
 * getUserAgent
 * Return userAgent string
 *
 * $type TFun([],TInst(String,[]))
 * public static function getUserAgent():String
 * @public
 * @static
 * @return {string} - string: userAgent string.
 */
com.inq.utils.Capabilities.getUserAgent = function() {
	if (com.inq.utils.Capabilities.userAgent == null) {
		com.inq.utils.Capabilities.userAgent = window.navigator.userAgent;
	}
	/** @type {string} */
	var userAgentCopy = com.inq.utils.Capabilities.userAgent;/*  Just make sure userAgent is not exposed to the world.*/
	return userAgentCopy;
};


/**
 * isMobile
 * Return true when the current device type is mobile.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isMobile():Bool
 * @public
 * @static
 * @return {boolean} - boolean: is the browser a "mobile" browser?
 */
com.inq.utils.Capabilities.isMobile = function() {
	if(com.inq.utils.Capabilities.mobile == null) com.inq.utils.Capabilities.mobile = com.inq.utils.Capabilities.isPhone() || com.inq.utils.Capabilities.isTablet();
	return com.inq.utils.Capabilities.mobile;
};


/**
 * isIphone
 * Return true when the current device is an iPhone.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isIphone():Bool
 * @public
 * @static
 * @return {boolean} - boolean: is the browser an iPhone?
 */
com.inq.utils.Capabilities.isIphone = function() {
	return com.inq.utils.Capabilities.isPhone() && com.inq.utils.Capabilities._getOS().indexOf("iPhone") != -1;
};

/**
 * Detects ios iPad devices based on navigator.platform 
 * and via document "ontouchend" iOS 13 and up detection 
 * (safari agent reports like a desktop)
 *
 * @return {boolean} - is an ipad if true
 */
com.inq.utils.Capabilities.isIpad = function() {
	var isMobilePlatform = [
		'iPad Simulator',
		'iPad'
	].includes(navigator.platform);
	// iPad on iOS 13 detection
	var isMacOsWithTouchSupport = (
		navigator.userAgent.includes("Mac") && "ontouchend" in document
	);

	return (isMobilePlatform || isMacOsWithTouchSupport);
};

/**
 * Determines whether this is IE10 running on Windows Phone.
 */
com.inq.utils.Capabilities.isIe10Phone = function() {
	var win = com.inq.utils.Capabilities.isWindowsPhone();
	var v = com.inq.utils.Capabilities.getIeVersion();
	return (win && (v >= 10));
};

/**
 * Retrieves the current effective version of IE.
 */
com.inq.utils.Capabilities.getIeVersion = function() {
	try {
		if (com.inq.utils.Capabilities.ieVersion != null) {
			return com.inq.utils.Capabilities.ieVersion;
		}
		else {
			var agent = com.inq.utils.Capabilities.getUserAgent();
			var m = agent.match(/(MSIE (\d+\.*\d*))|(IEMobile\/(\d+\.*\d+))/);
			var v = Std.parseInt(m[2] || m[4]);
			com.inq.utils.Capabilities.ieVersion = v;
			return v;
		}
	}
	catch (e) {
		return -1;
	}
};

/**
 * isPhone
 * Return true when the current device type is phone.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isPhone():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.utils.Capabilities.isPhone = function() {
	return com.inq.utils.Capabilities.getDeviceType() == "Phone";
};

/**
 * isTablet
 * Return true when the current device type is tablet.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isTablet():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.utils.Capabilities.isTablet = function() {
	return com.inq.utils.Capabilities.getDeviceType() == "Tablet";
};


/**
 * getDeviceType
 * Return device type as an string value.
 * FlashPeer.getDeviceType returns device type as string in three values Phone, Tablet, and Other
 *
 * $type TFun([],TInst(String,[]))
 * public static function getDeviceType():String
 * @public
 * @static
 * @return {string}
 */
com.inq.utils.Capabilities.getDeviceType = function() {
	if(com.inq.utils.Capabilities.deviceType == null) {

		com.inq.utils.Capabilities.deviceType = com.inq.flash.client.control.FlashPeer.getDeviceType();

		// if "Standard" double check if not ipad (detects as standard)
		if (com.inq.utils.Capabilities.deviceType == "Standard" && 
		    com.inq.utils.Capabilities.isIpad()) {
			com.inq.utils.Capabilities.deviceType = "Tablet";
		}

	}
	return com.inq.utils.Capabilities.deviceType;
};


/**
 * isChrome
 * True if userAgent string has 'chrome' in it and if string not contains 'edge'.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isChrome():Bool
 * @public
 * @static
 * @return {boolean} - boolean: is the browser "Chrome" browser
 */
com.inq.utils.Capabilities.isChrome = function() {
	return com.inq.utils.Capabilities.getUserAgent().toLowerCase().indexOf("edge") == -1 && com.inq.utils.Capabilities.getUserAgent().toLowerCase().indexOf("chrome") > -1 ;
};

/**
 * getChromeVersion Returns the integer ("big number") version of
 * Chrome that is running, or -1 if we're not on Chrome at all.
 *
 * @public
 * @static
 * @return {number} the version number of current Chrome version, or -1 if we're not on Chrome.
 */
com.inq.utils.Capabilities.getChromeVersion = function () {
	try {
		if (com.inq.utils.Capabilities.chromeVersion != null) {
			return com.inq.utils.Capabilities.chromeVersion;
		} else if (com.inq.utils.Capabilities.isChrome() == true) {
			var agent = com.inq.utils.Capabilities.getUserAgent();
			var m = agent.match(/Chrome\/(\d+)/);
			var v = Std.parseInt(m[1]);
			com.inq.utils.Capabilities.chromeVersion = v;
			return v;
		} else return -1;
	} catch (e) {
		return -1;
	}
};


/**
 * _isWebKit
 * Determines whether-or-not we have "Safari" in the user agent string
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function _isWebKit():Bool
 * @private
 * @static
 * @return {boolean} - boolean: is the browser "Safari" or "Chrome" browser (both browsers are based on WebKit)?
 */
com.inq.utils.Capabilities._isWebKit = function () {
	if (com.inq.utils.Capabilities.webKit != null) {
		return com.inq.utils.Capabilities.webKit;
	} else {
		/** @type {EReg} */
		var pattern = new EReg("(safari)", "i");
		com.inq.utils.Capabilities.webKit = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities.webKit;
	}
};

/**
 * Return true browser is Safari.
 * @return {boolean} true if Safari.
 */
com.inq.utils.Capabilities.isSafari = function(){
	if(com.inq.utils.Capabilities._isSafari !=null) {
		return com.inq.utils.Capabilities._isSafari;
	} else {
		var ua = com.inq.utils.Capabilities.userAgent.toLowerCase();
		com.inq.utils.Capabilities._isSafari = ua.indexOf("safari") >= 0
			   && !( ua.indexOf("chrome") >= 0
					 || ua.indexOf("crios") >= 0 ); // navigator.userAgent for Chrome has "Safari" inside the value}
		return com.inq.utils.Capabilities._isSafari;
	}
};

/**
 * isVersion8 - true if version 8 of safari, false if not
 * @public
 * @returns {boolean} true if version 8 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion8 = function () {
	if (com.inq.utils.Capabilities._isVersion8 != null)
		return com.inq.utils.Capabilities._isVersion8;
	else {
		/** @type {EReg} */
		var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/8)","i");
        com.inq.utils.Capabilities._isVersion8 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
        return com.inq.utils.Capabilities._isVersion8;
    }

};

/**
 * isVersion9 - true if version 9 of safari, false if not
 * @public
 * @returns {boolean} true if version 9 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion9 = function() {
	if(com.inq.utils.Capabilities._isVersion9 !=null)
		return com.inq.utils.Capabilities._isVersion9;
	else{
		/** @type {EReg} */
		var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/9)","i");
		com.inq.utils.Capabilities._isVersion9 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isVersion9;
	}

};

/**
 * isVersion10 - true if version 10 of safari, false if not
 * @public
 * @returns {boolean} true if version 10 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion10 = function() {
	if (com.inq.utils.Capabilities._isVersion10 != null) {
		return com.inq.utils.Capabilities._isVersion10;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/10)", "i");
		com.inq.utils.Capabilities._isVersion10 = pattern.match(com.inq.utils.Capabilities.getUserAgent());

		if(!com.inq.utils.Capabilities._isVersion10){
			var pattern = new EReg("(iPhone|iPad) OS 10.*AppleWebKit", "i");
			com.inq.utils.Capabilities._isVersion10 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		}
		return com.inq.utils.Capabilities._isVersion10;
	}
};


/**
 * isVersion11 - true if version 11 of safari, false if not
 * @public
 * @returns {boolean} true if version 11 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion11 = function() {
    if (com.inq.utils.Capabilities._isVersion11 != null) {
        return com.inq.utils.Capabilities._isVersion11;
    } else {
        var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/11)", "i");
		com.inq.utils.Capabilities._isVersion11 = pattern.match(com.inq.utils.Capabilities.getUserAgent());

        if(!com.inq.utils.Capabilities._isVersion11){
            var pattern = new EReg("(iPhone|iPad) OS 11.*AppleWebKit", "i");
			com.inq.utils.Capabilities._isVersion11 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
        }
        return com.inq.utils.Capabilities._isVersion11;
    }
};

/**
 * isVersion12 - true if version 12 of safari, false if not
 * @public
 * @returns {boolean} true if version 12 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion12 = function() {
    if (com.inq.utils.Capabilities._isVersion12 != null) {
        return com.inq.utils.Capabilities._isVersion12;
    } else {
        var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/12)", "i");
		com.inq.utils.Capabilities._isVersion12 = pattern.match(com.inq.utils.Capabilities.getUserAgent());

        if(!com.inq.utils.Capabilities._isVersion12){
            var pattern = new EReg("(iPhone|iPad) OS 12.*AppleWebKit", "i");
			com.inq.utils.Capabilities._isVersion12 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
        }
        return com.inq.utils.Capabilities._isVersion12;
    }
};

/**
 * isVersion13 - true if version 13 of safari, false if not
 * @public
 * @returns {boolean} true if version 13 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion13 = function() {
	if (com.inq.utils.Capabilities._isVersion13 != null) {
		return com.inq.utils.Capabilities._isVersion13;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/13)", "i");
		com.inq.utils.Capabilities._isVersion13 = pattern.match(com.inq.utils.Capabilities.getUserAgent());

		if(!com.inq.utils.Capabilities._isVersion13){
			var pattern = new EReg("(iPhone|iPad) OS 13.*AppleWebKit", "i");
			com.inq.utils.Capabilities._isVersion13 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		}
		return com.inq.utils.Capabilities._isVersion13;
	}
};

/**
 * isVersion14 - true if version 14 of safari, false if not
 * @public
 * @returns {boolean} true if version 14 of Safari
 */
com.inq.utils.Capabilities.isSafariVersion14orLater = function () {
	if (com.inq.utils.Capabilities._isVersion14orLater !== null) {
		return com.inq.utils.Capabilities._isVersion14orLater;
	} else {
		var safari14orLaterVersionsSupported = ["14", "15", "16", "17", "18", "19", "20"]; // add new available version of safari
		for(let i=0; i<safari14orLaterVersionsSupported.length; i++) {
			let ver = safari14orLaterVersionsSupported[i];
			var pattern1 = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*(Version\\/" + ver + ")", "i");
			var pattern2 = new EReg("(iPhone|iPad) OS " + ver + ".*AppleWebKit", "i");
			com.inq.utils.Capabilities._isVersion14orLater = pattern1.match(com.inq.utils.Capabilities.getUserAgent()) || pattern2.match(com.inq.utils.Capabilities.getUserAgent());
			if (com.inq.utils.Capabilities._isVersion14orLater) {
				return true;
			}
		};
		return com.inq.utils.Capabilities._isVersion14orLater;
	}
};

/**
 * isIOSWebView
 * @return {boolean}
 */

com.inq.utils.Capabilities.isIOSWebView = function() {
	if(com.inq.utils.Capabilities._isIOSWebView !=null)
		return com.inq.utils.Capabilities._isIOSWebView;
	else {
		var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)","i");
		com.inq.utils.Capabilities._isIOSWebView = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isIOSWebView || com.inq.utils.Capabilities.isIPadWebViewInDesktopMode();
	}
};

/**
 * keyword Macintosh is present only for mac desktop machines,
 * in case of ipad which is in desktop mode has Macintosh keyword
 * Keyword AppleWebKit is present only for safari and chrome browsers, both this browsers has Safari keyword also
 * @return {Boolean}
 */
com.inq.utils.Capabilities.isIPadWebViewInDesktopMode = function () {
    if (com.inq.utils.Capabilities._isIOSWebViewInDM != null) {
        return com.inq.utils.Capabilities._isIOSWebViewInDM;
    }
    else {
        var pattern = new RegExp("(Macintosh).*AppleWebKit(?!.*Safari)", "i");
        com.inq.utils.Capabilities._isIOSWebViewInDM = pattern.test(com.inq.utils.Capabilities.getUserAgent()) && (!com.inq.utils.Capabilities.isChrome());

        return com.inq.utils.Capabilities._isIOSWebViewInDM;
    }
};

/**
 * isAndroid WebView
 * below link tell how to detect webView useragent
 * @see https://developer.chrome.com/multidevice/user-agent
 * @return {boolean}
 */

com.inq.utils.Capabilities.isAndroidWebView = function() {
	if (com.inq.utils.Capabilities._isAndroidWebView != null) {
		return com.inq.utils.Capabilities._isAndroidWebView;
	} else {
		var pattern = new EReg("Android.*?(wv|Version\\/[.0-9]+).*?Chrome\\/([0-9]{2})", "i");
		com.inq.utils.Capabilities._isAndroidWebView = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isAndroidWebView;
	}
};

/**
 *	isVersionPrior8 - true if version before 8 of safari, false if not
 *	@returns {boolean} true if version 8 of Safari
 */
com.inq.utils.Capabilities.isSafariVersionPrior8 = function() {
    if(com.inq.utils.Capabilities._isVersionPrior8 !=null)
        return com.inq.utils.Capabilities._isVersionPrior8;
    else{
        var /** @type {EReg} */ pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*Version\\/(6|7)","i");
        com.inq.utils.Capabilities._isVersionPrior8 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
        return com.inq.utils.Capabilities._isVersionPrior8;
    }

};

/**
 *	isCriOS8 - true if Chrome on iOS 8, false if not
 *	@returns {boolean} true if Chrome on iOS 8
 */
com.inq.utils.Capabilities.isChromeiOS8 = function()
{
    if(com.inq.utils.Capabilities._isCriOS8 !=null)
        return com.inq.utils.Capabilities._isCriOS8;
    else{
	    /** @type {EReg} */
	    var pattern = new EReg("(iPhone|iPod|iPad).*(CPU\\s(iPhone|iPod|iPad)\\sOS\\s(6|7|8|9)_).*AppleWebKit?.*CriOS","i");
        com.inq.utils.Capabilities._isCriOS8 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
        return com.inq.utils.Capabilities._isCriOS8;
    }

};

/**
 *	isCriOS10 - true if Chrome on iOS 10, false if not
 *	@returns {boolean} true if Chrome on iOS 10
 */
com.inq.utils.Capabilities.isChromeiOS10 = function() {
	if (com.inq.utils.Capabilities._isCriOS10 != null) {
		return com.inq.utils.Capabilities._isCriOS10;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*(CPU.*\\sOS\\s10_).*AppleWebKit?.*CriOS", "i");
		com.inq.utils.Capabilities._isCriOS10 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isCriOS10;
	}
};

/**
 *	isCriOS11 - true if Chrome on iOS 11, false if not
 *	@returns {boolean} true if Chrome on iOS 11
 */
com.inq.utils.Capabilities.isChromeiOS11 = function() {
	if (com.inq.utils.Capabilities._isCriOS11 != null) {
		return com.inq.utils.Capabilities._isCriOS11;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*(CPU.*\\sOS\\s11_).*AppleWebKit?.*CriOS", "i");
		com.inq.utils.Capabilities._isCriOS11 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isCriOS11;
	}
};

/**
 *	isCriOS11 - true if Chrome on iOS 11, false if not
 *	@returns {boolean} true if Chrome on iOS 11
 */
com.inq.utils.Capabilities.isChromeiOS12 = function() {
	if (com.inq.utils.Capabilities._isCriOS12 != null) {
		return com.inq.utils.Capabilities._isCriOS12;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*(CPU.*\\sOS\\s12_).*AppleWebKit?.*CriOS", "i");
		com.inq.utils.Capabilities._isCriOS12 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isCriOS12;
	}
};

/**
 *	isCriOS13 - true if Chrome on iOS 13, false if not
 *	@returns {boolean} true if Chrome on iOS 13
 */
com.inq.utils.Capabilities.isChromeiOS13 = function() {
	if (com.inq.utils.Capabilities._isCriOS13 != null) {
		return com.inq.utils.Capabilities._isCriOS13;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*(CPU.*\\sOS\\s13_).*AppleWebKit?.*CriOS", "i");
		com.inq.utils.Capabilities._isCriOS13 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isCriOS13;
	}
};

/**
 *	isCriOS14 - true if Chrome on iOS 14, false if not
 *	@returns {boolean} true if Chrome on iOS 14
 */
com.inq.utils.Capabilities.isChromeiOS14 = function () {
	if (com.inq.utils.Capabilities._isCriOS14 !== null) {
		return com.inq.utils.Capabilities._isCriOS14;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*(CPU.*\\sOS\\s14_).*AppleWebKit?.*CriOS", "i");
		com.inq.utils.Capabilities._isCriOS14 = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isCriOS14;
	}
};

/**
 *	returns true if useragent string matches chrome on phone.
 * @return {boolean}
 */
com.inq.utils.Capabilities.isChromeOnIphone = function () {
	return (com.inq.utils.Capabilities.isPhone()
		&& (com.inq.utils.Capabilities.isChromeiOS14()
			|| com.inq.utils.Capabilities.isChromeiOS13()
			|| com.inq.utils.Capabilities.isChromeiOS12()
			|| com.inq.utils.Capabilities.isChromeiOS11()
			|| com.inq.utils.Capabilities.isChromeiOS10()
		)
	);
};


/**
 *	isCriOS - true if Chrome on iOS , false if not
 *	@returns {boolean} true if Chrome on iOS
 */
com.inq.utils.Capabilities.isChromeiOS = function() {
	if (com.inq.utils.Capabilities._isCriOS != null) {
		return com.inq.utils.Capabilities._isCriOS;
	} else {
		var pattern = new EReg("(iPhone|iPod|iPad).*AppleWebKit?.*CriOS", "i");
		com.inq.utils.Capabilities._isCriOS = pattern.match(com.inq.utils.Capabilities.getUserAgent());
		return com.inq.utils.Capabilities._isCriOS;
	}
};

/**
 * BindListener - attach an event handler to an HTML node.	This
 * centralizes decision-making about how to bind listeners.	 For
 * IE, we have to use the "attachEvent" function to bind the
 * listener.  Elsewhere, we can use the standard addEventListener
 * call.
 *
 * @public
 * @static
 * @param {EventTarget} node	The node where the event listener should be bound.
 * @param {string}  	event	The name of the event to listen for. (Ex. "scroll", "click", etc.)
 * @param {function}  	handler
 * @return {undefined}
 */
com.inq.utils.Capabilities.BindListener = function(node,event,handler) {
	if (null != window["addEventListener"]) {
		node.addEventListener(event, handler, false);
	} else if (null != window["attachEvent"]) {
		node.attachEvent("on" + event,handler)
	}
};

/**
 * UnbindListener - remove an event handler from an HTML node.
 *
 * $type TFun([{ name => node, t => TDynamic(null), opt => false },{ name => event, t => TInst(String,[]), opt => false },{ name => handler, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function UnbindListener(node:Dynamic, event:String, handler:Dynamic)
 * @public
 * @static
 * @param {null}  node
 * @param {string}  event
 * @param {null}  handler
 * @return {void}
 */
com.inq.utils.Capabilities.UnbindListener = function(node,event,handler) {
	if(null != window["removeEventListener"])
		node.removeEventListener(event,handler,false);
	else if(null != window["detachEvent"])
		node.detachEvent("on" + event,handler);
};

/**
 * isWindowsPhone
 * Return trye if "android" is found in userAgent string.
 * Optional testString for further tests
 *
 * example of UA: Mozilla/5.0 (Mobile; Windows Phone 8.1; Android 4.0; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; NOKIA; Lumia 925) like iPhone OS 7_0_3 Mac OS X AppleWebKit/537 (KHTML, like Gecko) Mobile Safari/537
 * public static function isWindowsPhone(testString:String):Bool
 * @public
 * @static
 * @param {string=} testString
 * @return {boolean} - boolean:
 */
com.inq.utils.Capabilities.isWindowsPhone = function(testString) {
	/** @type {boolean} */
	var matched = new EReg("Windows Phone", "i").match(com.inq.utils.Capabilities.getUserAgent());
	if (matched && testString != null) {
		matched = com.inq.utils.Capabilities.getUserAgent().indexOf(testString) != -1;
	}
	return matched;
};


/**
 * isAndroid
 * Return true if "android" is found in userAgent string.
 * Optional testString for further tests
 * $type TFun([],TEnum(Bool,[]))
 * public static function isAndroid():Bool
 * @public
 * @static
 * @param {string=} testString
 * @return {boolean} - boolean:
 */
com.inq.utils.Capabilities.isAndroid = function(testString) {
	// Matches anything with Android and NOT Windows.
	/** @type {boolean} */
	var matched = new EReg("^(?!.*windows)(?=.*android)", "i").match(com.inq.utils.Capabilities.getUserAgent());
	if (matched && testString != null) {
		matched = com.inq.utils.Capabilities.getUserAgent().indexOf(testString) != -1;
	}
	return matched;
};

/**
 * getDefaultResizeArea
 * Determines the appropriate area for the draggable resize
 * button.
 *
 * $type TFun([],TInst(com.inq.utils.Area,[]))
 * public static function getDefaultResizeArea():Area
 * @public
 * @static
 * @return {com.inq.utils.Area}
 */
com.inq.utils.Capabilities.getDefaultResizeArea = function() {
	/** @type {com.inq.utils.Area} */
	var a;
	if (com.inq.utils.Capabilities.isMobile()) {
		a = new com.inq.utils.Area(0, 0, 32, 32);
	} else {
		a = new com.inq.utils.Area(0, 0, 16, 16);
	}
	return a;
};

/**
 * isFF
 * True if InstallTrigger in not 'undefined' and if the userAgent string contains 'firefox'.
 *
 * @public
 * @static
 * @return {boolean} - boolean: is the browser "FireFox" browser
 */
com.inq.utils.Capabilities.isFF = function() {
	return (typeof InstallTrigger !== "undefined") && (com.inq.utils.Capabilities.getUserAgent().toLowerCase().indexOf("firefox") != -1);
};

/**
 * isAutoZoom
 * Determines whether the device will automatically zoom in to
 * text entry form elements.  This is all (for now) hard-coded
 * based on experiments with available hardware.
 *
 * NOTE that this method does NOT tell you anything about the
 * current viewport.  This simply answers the question, "Does the
 * user's device auto-zoom into text entry fields by default?"	If
 * anything (user settings, HTML, client JavaScript, etc.) stomps
 * on the default setting, the actual behavior for the user WILL
 * differ from what's predicted by this method.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isAutoZoom():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.utils.Capabilities.isAutoZoom = function() {
	/** @type {boolean} */
	var result = false;
	if (com.inq.utils.Capabilities.isMobile()) {
		if (new EReg("android", "i").match(com.inq.utils.Capabilities.getUserAgent())
			&& new EReg("a100|a200|transformer tf101|transformer tf300|gt-p6210|gt-p7100|sony tablet s|kindle fire", "i").match(com.inq.utils.Capabilities.getUserAgent())) {
            /*
             a100    - Acer Iconia Tab A100 7\" tablet"
             a200    - Acer Iconia Tab A200 10.1\" tablet
             transformer tf101   - Asus Transformer TF101 tablet
             transformer tf300   - Asus Transformer TF300 tablet
             gt-p6210            - Samsung Galaxy Tab 7\" tablet
             gt-p7100            - Samsung Galaxy Tab 10.1\" tablet
             sony tablet s       - Sony Tablet S tablet
             kindle fire         - Kindle Fire
            */
            result = false;  // Easy to read.
        } else {
            result = true;
        }
    }
    return result;
};


/**
 * getViewport - Determines the current viewable area on the
 * screen.	Note that on iOS this does NOT take into account the
 * on-screen keyboard.	Where necessary, we compensate for this
 * shortcoming by scrolling all the way to the bottom of the page
 * and THEN calling getViewport.
 *
 * $type TFun([],TInst(com.inq.utils.Area,[]))
 * public static function getViewport():Area
 * @public
 * @static
 * @return {com.inq.utils.Area}
 */
com.inq.utils.Capabilities.getViewport = function() {
	/** @type {number} */
	var x = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
	/** @type {number} */
	var y = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
	/** @type {com.inq.utils.Area} */
	var vp;
	if (com.inq.utils.Capabilities.isAndroid()
		&& (!com.inq.utils.Capabilities.isChrome() || com.inq.utils.Capabilities.getChromeVersion() < 40)) {
		/** @type {com.inq.utils.Point} */
		var bug = com.inq.utils.Capabilities.getLowerRightCorner();
		vp = new com.inq.utils.Area(x, y, bug.x, bug.y);
	}
	else { /* Non-Android browsers, and Android running Chrome 40+ */
		/*  BUG: This returns inconsistent values.*/
		/** @type {?number} */
		var w = Std.parseInt(window.parent.innerWidth);
		/** @type {?number} */
		var h = Std.parseInt(window.parent.innerHeight);
		vp = new com.inq.utils.Area(x, y, w, h);
	}
	return vp;
};

/**
 * getOrientation - returns the orientation of the browser, if no orientation defaults
 * @return {boolean} true if portrait, false if landscape
 */

com.inq.utils.Capabilities.getOrientation = function() {
	// orientation does not exist in many desktop browsers.  So assume "Portrait" mode when no orientation facility exists
	/** @type {boolean} */
	var portrait = ("orientation" in window)
		? (((window.parent.orientation + 360) % 180) === 0)
		: true ;
	/*
	 * MOB-368: Mobile Chrome has a bug which causes it to initially
	 * report the orientation incorrectly.  We compensate for this by
	 * checking the height/width directly.
	 * Note: Fred says that this is not the full Fix.  The problem arizes on some Chrome browsers due to an error in detecting oreintation change.
	 *       This has been discovered in mobile Chrome in versions 33 through 35.  It is tasked to be fixed in version 36.
	 *       Please see: https://code.google.com/p/chromium/issues/detail?id=347507
	 *
	 * RTDEV-6776 change is because (orientation WORKS and screen size NOT WORKS) on Chrome earlier than version 33
	 *      ex) NEXUS 5 with Chrome 30.0.1599.105
	 */
	if (com.inq.utils.Capabilities.isChrome()) {
		/** @type {Number} */
		var bver = parseInt(window.navigator.appVersion.match(/Chrome\/(\d+)\./)[1], 10);
		/* 
		 * MOB-730: Mobile chrome version 33 above until 35 is giving false value for screen.width and screen.height while changing the orientation.
		 * To fix this discrepancy I have used outerWidth and outerHeight to detect orientation.
		 * Chrome version prior to 33 have correct value from line #424. Hence we rely on that value to detect the orientation
		 */
		/** @type {Window}*/
		var tpwin = window.top;
		if ( isNaN(bver) ||  bver>=33 && bver<=35) {
			portrait = (tpwin.outerWidth < tpwin.outerHeight);
		}
		else if(bver>=36)
			portrait = (tpwin.screen.width < tpwin.screen.height);
	}
	return portrait;
};



/** getScreenHeight - This routine is ONLY to be used by the iOS8 ChatTextFocusMonitor
 * Returns the correct screen height for iPhones iPads and other mobile devices
 *
 * iPhones and iPads switch available height and width according to orientation
 *  iPhone assumes proper orientation is portrait and switches width/height in landscape
 *  iPad assumes proper orientation is landscape and switches width/height in portrait.
 * This getter takes account of this ios quirk and returns the correct value
 *
 * @see http://jira.touchcommerce.com/browse/MOB-609
 * @returns {number} screen height
 */
com.inq.utils.Capabilities.getScreenHeight = function () {
	/** @type {Window} */
	var clientWin = window.top;
	if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Capabilities.isIpad()) {
		/** @type {boolean}*/
		var isPortrait = com.inq.utils.Capabilities.getOrientation();
		if (isPortrait) {
			return (clientWin.screen.height > clientWin.screen.width)
				?clientWin.screen.height
				:clientWin.screen.width;
		}  else {
		   return (clientWin.screen.height > clientWin.screen.width)
				?clientWin.screen.width
				:clientWin.screen.height;

		}
	} else {
		return clientWin.screen.height;
	}
};

/** getScreenWidth - This routine is ONLY to be used by the iOS8 ChatTextFocusMonitor
 * Returns the correct screen height for iPhones iPads and other mobile devices
 *
 * iPhones and iPads switch available height and width according to orientation
 *  iPhone assumes proper orientation is portrait and switches width/height in landscape
 *  iPad assumes proper orientation is landscape and switches width/height in portrait.
 * This getter takes account of this ios quirk and returns the correct value
 *
 * @see http://jira.touchcommerce.com/browse/MOB-609
 * @returns {number} screen height
 */
com.inq.utils.Capabilities.getScreenWidth = function () {
	/** @type {Window} */
	var clientWin = window.top;
	if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Capabilities.isIpad()) {
		/** @type {boolean}*/
		var isPortrait = com.inq.utils.Capabilities.getOrientation();
		if (isPortrait) {
			return (clientWin.screen.height > clientWin.screen.width)
				?clientWin.screen.width
				:clientWin.screen.height;
		}  else {
		   return (clientWin.screen.height > clientWin.screen.width)
				?clientWin.screen.height
				:clientWin.screen.width;

		}
	} else {
		return clientWin.screen.width;
	}
};

/** getAvailHeight - This routine is ONLY to be used by the iOS8 ChatTextFocusMonitor
 *
 * iPhones and iPads switch available height and width according to orientation
 *  iPhone assumes proper orientation is portrait and switches width/height in landscape
 *  iPad assumes proper orientation is landscape and switches width/height in portrait.
 * This getter takes account of this ios quirk and returns the correct value
 *
 * @see http://jira.touchcommerce.com/browse/MOB-609
 * @returns {number} screen availHeight
 */
com.inq.utils.Capabilities.getAvailHeight = function() {
	/** @type {Window} */
	var clientWin = window.top;
	if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Capabilities.isIpad()) {
		/** @type {boolean}*/
		var isPortrait = com.inq.utils.Capabilities.getOrientation();
		if (isPortrait) {
			return (clientWin.screen.availHeight > clientWin.screen.availWidth)
				?clientWin.screen.availHeight
				:clientWin.screen.availWidth;
		}  else {
		   return (clientWin.screen.availHeight > clientWin.screen.availWidth)
				?clientWin.screen.availWidth
				:clientWin.screen.availHeight;

		}
	}
	return clientWin.screen.availHeight;
};

/**
 * isChromed - "Chromed" state is when the browser fills the entire screen
 * @private
 * @return {boolean} true if full screen
 */
com.inq.utils.Capabilities.isChromed = function() {
	/** @type {Window} */
	var clientWin = window.top;
	return (clientWin.innerHeight === com.inq.utils.Capabilities.getAvailHeight()) ;
};

/**
 * getZoom - Determines the current zoom level of the screen.
 * Rounds to two decimal places to avoid issues comparing
 * Floats. (ex: 3.145723495827340598275028345 !=
 * 3.145723495827340598275028344)
 *
 * $type TFun([],TInst(Float,[]))
 * public static function getZoom():Float
 * @public
 * @static
 * @return {number} - the current zoom factor (physical pixels per css pixel) ROUNDED to two decimal places.
 */
com.inq.utils.Capabilities.getZoom = function () {
	try {
		/** @type {com.inq.utils.Area} */
		var vp = com.inq.utils.Capabilities.getViewport();/*  CSS pixels*/
		/** @type {?number} */
		var rw = Std.parseInt(window.parent.screen.width);/*  REAL width of screen, in physical pixels.*/
		/** @type {number} */
		var z = Math.round(100 * (rw / vp.w)) / 100;
		return z;
	} catch(err) {
		return 1;
	}
};


/**
 * getLowerRightCorner
 *
 * $type TFun([],TInst(com.inq.utils.Point,[]))
 * private static function getLowerRightCorner():Point
 * @private
 * @static
 * @return {com.inq.utils.Point} - the position (in CSS pixels) of zoom detection div.
 */
com.inq.utils.Capabilities.getLowerRightCorner = function() {
	if (window.top.pageYOffset == 0) {
		window.top.scrollBy(0, 1);
	}
	com.inq.utils.Capabilities.initZoomDetection();
	/** @type {number} */
	var x = com.inq.utils.Capabilities.viewportDetector.offsetLeft - com.inq.utils.Capabilities.viewportDetector.parentNode.scrollLeft;
	/** @type {number} */
	var y = com.inq.utils.Capabilities.viewportDetector.offsetTop - com.inq.utils.Capabilities.viewportDetector.parentNode.scrollTop;
	x = x + 1;/*  Compensate for the height of the div.*/
	y = y + 1;/* */

	/*
	 * @see http://jira.touchcommerce.com/browse/RTDEV-9542
	 * @description if viewportDetected element is really fixed and within the viewport then we should use parent innerHeight property
	 */

	if(com.inq.utils.Capabilities.isTablet()) {
		if(com.inq.utils.Capabilities.viewportDetector.offsetTop +1 === window.parent.innerHeight) {
			y = window.parent.innerHeight;
		}
		if(com.inq.utils.Capabilities.viewportDetector.offsetLeft +1 === window.parent.innerWidth) {
			x = window.parent.innerWidth;
		}
	}
	return new com.inq.utils.Point(x,y);
};


/**
 * initZoomDetection
 * We use a single-pixel div in the lower-right corner of the
 * screen to determine the current zoom level and viewport size.
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function initZoomDetection():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.utils.Capabilities.initZoomDetection = function() {
	try {
		if(!com.inq.utils.Capabilities.viewportDetectorInitialized) {
			/** @type {Element} */
			var pix = window.parent.document.createElement("DIV");
			pix.style.position = "fixed";
			pix.style.height = "1px";
			pix.style.width = "1px";
			pix.style.right = "0px";
			pix.style.bottom = "0px";
			com.inq.utils.Capabilities.viewportDetector = pix;
			window.parent.document.body.appendChild(com.inq.utils.Capabilities.viewportDetector);
			com.inq.utils.Capabilities.viewportDetectorInitialized = true;
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace(e,{ fileName : "Capabilities.hx", lineNumber : 387, className : "com.inq.utils.Capabilities", methodName : "initZoomDetection"});
		} else throw(e);
	}
};


/**
 * waitFor
 * Provides a means for client code to be called back when a given condition is met.
 *
 * $type TFun([{ name => test, t => TFun([],TEnum(Bool,[])), opt => false },{ name => interval, t => TInst(Int,[]), opt => false },{ name => cb, t => TFun([],TDynamic(null)), opt => false },{ name => max, t => TInst(Int,[]), opt => false },{ name => ripples, t => TInst(Int,[]), opt => true }],TDynamic(null))
 * public static function waitFor(test:Void->Bool, interval:Int, cb:Void->Dynamic, max:Int, ripples:Int=1):Dynamic
 * @public
 * @static
 * @param {function}  test - A function that returns a boolean.
 * @param {number}  interval - (milliseconds) How often should we test?
 * @param {function}  cb - A callback function to be called when test() returns true.  (I tried calling this "callback", but Haxe became enraged.)
 * @param {number}  max - The maximum number of times to try before giving up.
 * @param {number}  ripples
 * @return {number}
 */
com.inq.utils.Capabilities.waitFor = function (test,interval,cb,max,ripples) {
	if(ripples == null) ripples = 1;
	/** @type {number} */
	var count = 0;
	/** @type {number} */
	var token = window.setInterval(function () {
		haxe.Log.trace("interval[count: " + count + ", max: " + max + ", ripples: " + ripples + "]",{ fileName : "Capabilities.hx", lineNumber : 402, className : "com.inq.utils.Capabilities", methodName : "waitFor"});
		if(max != null && ++count > max) window.clearInterval(token); else if(test()) {
			if(--ripples <= 0) window.clearInterval(token);
			count = 0;/*  Reset to the original max count.*/
			cb();
		}
	}, interval);
	return token;
};


/**
 * iOS has a nasty bug which intermittently (or maybe not
 * intermittently) causes rendering bugs when we attempt to edit the
 * DOM from a function called via setTimeout.
 *
 * To get around this, we can set up a one-off DOM event type, create
 * a listener for that type, and then trigger that listener by firing
 * that one-off DOM event.  Kind of roundabout, but it ensures that
 * the DOM is ready for editing, and prevents rendering bugs.
 *
 * @param {Function} f The function to call.
 * @param {number} t The time delay (in ms) after which to call the function.
 * @return {*} A token which can be used to clear the timeout.
 */
com.inq.utils.Capabilities.setDomSafeTimeout = function(f, t) {
    // We can't re-use event types, because we need to ensure that no
    // timeout is called prematurely.
    var random = (Math.random() + "").substring(2); // Strip off "0." at the beginning.
    var type = "domsafe" + random;
    var h = function() {
        com.inq.utils.Capabilities.UnbindListener(window, type, h);
        f();
    };
    com.inq.utils.Capabilities.BindListener(window, type, h);
    var token = window.setTimeout(function() {
        window.dispatchEvent(new Event(type));
    }, t);

    // In order to properly cancel this timeout, we need three pieces
    // of information that are in scope here, and we need to clean up
    // the event handler. This "token" will (intentionally) be useless
    // if passed to window.clearTimeout.
    return {
        clear: function() {
            window.clearTimeout(token);
            com.inq.utils.Capabilities.UnbindListener(window, type, h);
        }
    };
};

/**
 * viewportStopsMoving
 * Returns a function which determines whether the viewport has
 * moved during the specified time.  This is useful mostly to pass
 * the resulting function to waitFor().
 *
 * $type TFun([{ name => time, t => TInst(Int,[]), opt => false }],TFun([],TEnum(Bool,[])))
 * @public
 * @static
 * @param {number}  time - The number of milliseconds the viewport must remain still.
 * @return {function} - A function that returns a boolean indicating whether the viewport has moved in the specified time.
 */
com.inq.utils.Capabilities.viewportStopsMoving = function(time) {
	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();
	/** @type {number} */
	var t = new Date().getTime();
	return function () {
		/** @type {number} */
		var now = new Date().getTime();
		/** @type {number} */
		var dt = now - t;
		/** @type {com.inq.utils.Area} */
		var newVp = com.inq.utils.Capabilities.getViewport();
		/** @type {boolean} */
		var eq = vp.equals(newVp);
		haxe.Log.trace("viewportStopsMoving[dt: " + dt + ", time: " + time + "]",{ fileName : "Capabilities.hx", lineNumber : 434, className : "com.inq.utils.Capabilities", methodName : "viewportStopsMoving"});
		if(eq) {
			haxe.Log.trace("viewport has remained the same for " + dt + "ms.",{ fileName : "Capabilities.hx", lineNumber : 436, className : "com.inq.utils.Capabilities", methodName : "viewportStopsMoving"});
			if(dt > time) {
				t = now;
				return true;
			} else return false;
		} else {
			haxe.Log.trace("viewport has changed.",{ fileName : "Capabilities.hx", lineNumber : 446, className : "com.inq.utils.Capabilities", methodName : "viewportStopsMoving"});
			t = now;
			vp = newVp;
			return false;
		}
	};
};

com.inq.utils.Capabilities.getIOSNativeSDKInstance = function() {
	return window.top.webkit && window.top.webkit.messageHandlers && window.top.webkit.messageHandlers.NuanIJSFBridge;
};

/**
 * extractBrowserNameAndVersion
 *
 * $type TFun([{ name => userAgent, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function extractBrowserNameAndVersion(userAgent:String):String
 * @public
 * @static
 * @param {string}  userAgent
 * @return {string}
 */
com.inq.utils.Capabilities.extractBrowserNameAndVersion = function(userAgent) {
	/** @type {String} */
	var replaceWith = null;
	/** @type {EReg} */
	var pattern = null;
	/** @type {Array} */
	var patternTable = [
		{ browser : "IOS WebView", pattern : "(.*)(iPhone|iPod|iPad)(.*)AppleWebKit(?!.*Safari)(.*)", replaceWith : "IOS WebView"},
		{ browser : "Android WebView", pattern : "(.*?)Android(.*?)(wv|Version\\/[.0-9]+)(.*?)Chrome\\/([0-9]{2})(.*?)Mobile(.*)", replaceWith : "Android WebView/Stock Browser - Chrome $5"},
		{ browser : "Edge", pattern : "(.*)(Edge)(/)([0-9.]*)", replaceWith : "Edge $4"},
		{ browser : "Edge", pattern : "(.*)(Edg)(/)([0-9.]*)", replaceWith : "Edge $4"},
		{ browser : "Android Browser", pattern : ".*Android(?!.*Chrome)(?=.*Mobile Safari).*Version/([0-9.]+).*", replaceWith : "Android Browser $1"},
		{ browser : "Chrome", pattern : "(.*)(Chrome)([/| ])([0-9a-zA-Z.]*)( .*)", replaceWith : "Chrome $4"},
		{ browser : "Chrome", pattern : "(.*?)(AppleWebKit)(.*?) CriOS/([0-9]{2,})(.*?)Safari(.*)", replaceWith : "Chrome $4"},
		{ browser : "IE", pattern : "(.*)(Trident)(/)([0-9.]*)(.*)", replaceWith : "$4", ieVersionCorrection: 4},
		{ browser : "IE", pattern : "(.*)(MSIE)( )([0-9.]*)(;.*)", replaceWith : "IE $4"},
		{ browser : "IE", pattern : "(.*)(MSIE)(.*)", replaceWith : "IE"},
		{ browser : "Firefox", pattern : "(.*)(Gecko)([/ ])([0-9]*)(.*)(Firefox)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$6 $8 $4"},
		{ browser : "Firefox", pattern : "(.*)(Firefox)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Firefox", pattern : "(.*)(Firefox)(.*)", replaceWith : "$2"},
		{ browser : "Safari", pattern : "(.*)(AppleWebKit)(.*)(Version)([/| ])([0-9a-zA-Z.]*)( .*)", replaceWith : "Safari $6"},
		{ browser : "Safari", pattern : "(.*)(AppleWebKit)(.*)", replaceWith : "Safari"},
		{ browser : "Opera", pattern : "(.*)(Opera)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Opera", pattern : "(.*)(Opera)(.*)", replaceWith : "$2"},
		{ browser : "Lobo", pattern : "(.*)(Lobo)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Beonex", pattern : "(.*)(Beonex)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "BonEcho", pattern : "(.*)(BonEcho)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Camino", pattern : "(.*)(Camino)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Chimera", pattern : "(.*)(Chimera)([/| ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Dillo", pattern : "(.*)(Dillo)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Elinks", pattern : "(.*)(Elinks)([/ (])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Epiphany", pattern : "(.*)(Epiphany)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Firebird", pattern : "(.*)(Firebird)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Flock", pattern : "(.*)(Flock)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Galeon", pattern : "(.*)(Galeon)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "GranParadiso", pattern : "(.*)(GranParadiso)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "IBrowse", pattern : "(.*)(IBrowse)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "iCab", pattern : "(.*)(iCab)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Iceape", pattern : "(.*)(Iceape)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Iceweasel", pattern : "(.*)(Iceweasel)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "K-Meleon", pattern : "(.*)(K-Meleon)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "K-Ninja", pattern : "(.*)(K-Ninja)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Kazehakase", pattern : "(.*)(Kazehakase)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Links", pattern : "(.*)(Links)([/( ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Lynx", pattern : "(.*)(Lynx)([y/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Minefield", pattern : "(.*)(Minefield)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "MultiZilla", pattern : "(.*)(MultiZilla)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Mosaic", pattern : "(.*)(Mosaic)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "NetNewsWire", pattern : "(.*)(NetNewsWire)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Netscape", pattern : "(.*)(Netscape)([6]*)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $5"},
		{ browser : "OmniWeb", pattern : "(.*)(OmniWeb)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Oregano", pattern : "(.*)(Oregano)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Phoenix", pattern : "(.*)(Phoenix)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "SeaMonkey", pattern : "(.*)(SeaMonkey)([/ ]*)([0-9a-zA-Z.]*)(.*)", replaceWith : "$2 $4"},
		{ browser : "Shiira", pattern : "(.*)(Shiira)([/ ]*)(([0-9][0-9a-zA-Z.]*)|([ ]))(.*)", replaceWith : "$2 $4"},
		{ browser : "Sunrise", pattern : "(.*)(Sunrise)([/ ]*)(([0-9][0-9a-zA-Z.]*)|([ ]))(.*)", replaceWith : "$2 $4"},
		{ browser : "Netscape", pattern : "(.*)(Mozilla)([/ ])([0-9a-zA-Z.]*)(.*)", replaceWith : "Netscape $4"}
	];

	for (var i = 0; i < patternTable.length; i++) {
		pattern = new EReg(patternTable[i].pattern,"i");
		replaceWith = patternTable[i].replaceWith;
		/** @type {boolean} */
		var b = pattern.match(userAgent);
		if(b) {
			var version = pattern.replace(userAgent,replaceWith);
			//for IE:	if userAgent contains Trident, the version of the browser is defined as version of Trident + 4
			var versionCorrection = patternTable[i].ieVersionCorrection;
			if (versionCorrection) {
				return "IE " + new String(new Number(version) + versionCorrection) + ".0";
			}
			return version;
		}
	}
	return "Unknown";
};


/**
 * This function returns exact iPhone model as a string
 *
 * To determinate exact iPhone model and it's display zoom mode (for 6+, 7+ and 8+) we are checking screen dimensions,
 * pixel density and GPU model. Every iPhone could be uniquely determined by this parameters as long as Apple don’t block
 * this information in the future.
 *
 * @return {string}
 */
com.inq.utils.Capabilities.getiPhoneModel = function() {
	/**
	 * We need to cache the result from this function because Safari on iOS throws an error if we create too many canvases and call
	 * canvas.getContext() too many times: "There are too many active WebGL contexts on this page"
	 */
	if (com.inq.utils.Capabilities._iPhoneModel !== null) {
		return com.inq.utils.Capabilities._iPhoneModel;
	}

	/** @type {?string} */
	var result = null;

	var canvas = document.createElement("canvas"); // Create a canvas element which can be used to retrieve information about the GPU.
	if (canvas) {
		var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
		if (context) {
			var info = context.getExtension("WEBGL_debug_renderer_info");
			if (info) {
				var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
			}
		}
	}
	var screenHeightToWidthRatio  = window.parent.screen.height / window.parent.screen.width;

	if (screenHeightToWidthRatio == 844 / 390 && window.devicePixelRatio == 3) {
		switch(renderer) {
		  case "Apple A12 GPU": 
			result = "iPhone12";
			break;
		  default:
			result = "iPhone12";
		}
	} else if (screenHeightToWidthRatio == 926 / 428 && window.devicePixelRatio == 3) {
		switch(renderer) {
		  case "Apple A12 GPU": 
			result = "iPhone12ProMax";
			break;
		  default:
			result = "iPhone12ProMax";
		}
	} else if (screenHeightToWidthRatio == 896 / 414 && window.devicePixelRatio == 3) {
		switch (renderer) {
			case "Apple A12 GPU":
				result = "iPhoneXSMax";
				break;
			default:
				result = "iPhoneXSMax";
		}
	} else if (screenHeightToWidthRatio == 896 / 414 && window.devicePixelRatio == 2) {
		switch (renderer) {
			case "Apple A12 GPU":
				result = "iPhoneXR";
				break;
			default:
				result = "iPhoneXR";
		}
	} else if (screenHeightToWidthRatio == 812 / 375 && window.devicePixelRatio == 3) {
		switch (renderer) {
			case "Apple A12 GPU":
				result = "iPhoneXS_XSMaxZoomed";
				break;
			case "Apple A11 GPU":
				result = "iPhoneX";
				break;
			default:
				result = "iPhoneX";
		}
	} else if (screenHeightToWidthRatio == 812 / 375 && window.devicePixelRatio == 2) {
		switch (renderer) {
			case "Apple A12 GPU":
				result = "iPhoneXRZoomed";
				break;
			default:
				result = "iPhoneXRZoomed";
		}
	} else if ((screenHeightToWidthRatio == 736 / 414) && (window.devicePixelRatio == 3)) { // iPhone 6+/6s+/7+ and 8+
		switch (renderer) {
			case "Apple A8 GPU":
				result = "iPhone6Plus";
				break;
			case "Apple A9 GPU":
				result = "iPhone6sPlus";
				break;
			case "Apple A10 GPU":
				result = "iPhone7Plus";
				break;
			case "Apple A11 GPU":
				result = "iPhone8Plus";
				break;
			default:
				result = "iPhone6Plus";
		}
	} else if ((screenHeightToWidthRatio == 667 / 375) && (window.devicePixelRatio == 3)) { // iPhone 6+/6s+/7+ and 8+ in zoom mode
		switch(renderer) {
			case "Apple A8 GPU":
				result = "iPhone6PlusZoomed";
				break;
			case "Apple A9 GPU":
				result = "iPhone6sPlusZoomed";
				break;
			case "Apple A10 GPU":
				result = "iPhone7PlusZoomed";
				break;
			case "Apple A11 GPU":
				result = "iPhone8PlusZoomed";
				break;
			default:
				result = "iPhone6PlusZoomed";
		}
	} else if ((screenHeightToWidthRatio == 667 / 375) && (window.devicePixelRatio == 2)) { // iPhone 6/6s/7 and 8
		switch(renderer) {
			case "Apple A8 GPU":
				result = "iPhone6";
				break;
			case "Apple A9 GPU":
				result = "iPhone6s";
				break;
			case "Apple A10 GPU":
				result = "iPhone7";
				break;
			case "Apple A11 GPU":
				result = "iPhone8";
				break;
			default:
				result = "iPhone6";
		}
	} else if ((screenHeightToWidthRatio == 1.775) && (window.devicePixelRatio == 2)) { // iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
		switch(renderer) {
			case "PowerVR SGX 543":
				result = "iPhone5";
				break;
			case "Apple A7 GPU":
				result = "iPhone5s";
				break;
			case "Apple A8 GPU":
				result = "iPhone6Zoomed";
				break;
			case "Apple A9 GPU":
				result = "iPhone6sZoomed";
				break;
			case "Apple A10 GPU":
				result = "iPhone7Zoomed";
				break;
			case "Apple A11 GPU":
				result = "iPhone8Zoomed";
				break;
			default:
				result = "iPhone6Zoomed";
		}
	} else if ((screenHeightToWidthRatio == 1.5) && (window.devicePixelRatio == 2)) { // iPhone 4/4s
		switch(renderer) {

			case "PowerVR SGX 535":
				result = "iPhone4";
				break;
			case "PowerVR SGX 543":
				result = "iPhone4s";
				break;
			default:
				result = "iPhone4s";
		}
	} else if ((screenHeightToWidthRatio == 1.5) && (window.devicePixelRatio == 1)) { // iPhone 1/3G/3GS
		switch(renderer) {
			case "ALP0298C05":
				result = "iPhone 3GS";
				break;
			case "S5L8900":
				result = "iPhone 1, 3G";
				break;
			default:
				result = "iPhone 1, 3G or 3GS";
		}
	} else {
		result = "Not an iPhone";
	}

	com.inq.utils.Capabilities._iPhoneModel = result;
	return com.inq.utils.Capabilities._iPhoneModel;
};

/**
 * isIPhoneXOrNewer
 * Return true if "iPhone X" or newer
 * @public
 * @static
 * @return {boolean}
 */
com.inq.utils.Capabilities.isIPhoneXOrNewer = function() {
	return com.inq.utils.Capabilities.getiPhoneModel().indexOf("iPhoneX") !== -1;
};

/**
 * This function returns exact iPad model as a string
 *
 *  To determinate exact iPad model and it's display mode (for 6+, 7+ and 8+) we are checking screen dimensions,
 * pixel density and GPU model. Every iPhone could be uniquely determined by this parameters as long as Apple don’t block
 * this information in the future.
 *
 * @return {string}
 */
com.inq.utils.Capabilities.getiPadModel = function(){
	var canvas = document.createElement("canvas"); // Create a canvas element which can be used to retreive information about the GPU.
	if (canvas) {
		var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
		if (context) {
			var info = context.getExtension("WEBGL_debug_renderer_info");
			if (info) {
				var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
			}
		}
	}

	if(window.parent.screen.height / window.parent.screen.width == 1024 / 768) {
		if (window.devicePixelRatio == 1) { // iPad, iPad 2, iPad Mini
			switch(renderer) {
				case "PowerVR SGX 535":
					return "iPad"
				case "PowerVR SGX 543":
					return "iPad 2 or Mini";
				default:
					return "iPad, iPad 2, iPad Mini";
			}
		} else { // iPad 3, 4, 5, Mini 2, Mini 3, Mini 4, Air, Air 2
			switch(renderer) {
				case "PowerVR SGX 543":
					return "iPad 3";
				case "PowerVR SGX 554":
					return "iPad 4";
				case "Apple A7 GPU":
					return "iPad Air, Mini 2, Mini 3";
				case "Apple A8X GPU":
					return "iPad Air 2";
				case "Apple A8 GPU":
					return "iPad Mini 4";
				case "Apple A9 GPU":
					return "iPad 5, Pro 9.7";
				default:
					return "iPad 3, 4, 5, Mini 2, Mini 3, Mini 4, Air, Air 2";
			}
		}
	} else if (window.parent.screen.height / window.parent.screen.width == 1112 / 834) { // iPad Pro 10.5
		return "iPad Pro 10.5";
	} else if (window.parent.screen.height / window.parent.screen.width == 1366/ 1024) { // iPad Pro 12.9, Pro 12.9 (2nd Gen)
		switch(renderer) {
			case "Apple A10X GPU":
				return "iPad Pro 12.9 (2nd Gen)";
			case "Apple A9 GPU":
				return "iPad Pro 12.9";
			default:
				return "iPad Pro 12.9, Pro 12.9 (2nd Gen)";
		}
	} else {
		return "Not an iPad";
	}
};

/**
 * setOrigViewPortHeight
 *
 *  This method sets the current viewport height. This method is intended to be invoked during class inits
 *  and during orientation change. Note that for iPhones, this is the actual viewport height because the
 *  top address bar and bottom bookmark bar is visible. When you scroll on an iphone browser, the viewport
 *  height changes (increases) because the top address bar and bottom bookmark bar will be hidden.
 *
 * @return {void }
 */
com.inq.utils.Capabilities.setOrigViewPortHeight = function () {
    com.inq.utils.Capabilities._origViewPortHeight = parseInt(window.parent.innerHeight);
};

/**
 * getOrigViewPortHeight
 *
 *  This method gets the original viewport height.
 *
 * @return {int} - the viewport height
 */
com.inq.utils.Capabilities.getOrigViewPortHeight = function () {
    return com.inq.utils.Capabilities._origViewPortHeight;
};

/** @type {com.inq.utils.Capabilities} */
com.inq.utils.Capabilities.prototype.__class__ = com.inq.utils.Capabilities;
/** @private @type {Array} */
com.inq.utils.Capabilities.patternTable = [
	"[\\s]*Mozilla[/ ][0-9a-zA-Z.]*\\s[(][^;]*;[^;]*;\\s*America Online[^;]*;[^;]*;([^;\\)]*).*",
	"[\\s]*Mozilla[/ ][0-9a-zA-Z.]*\\s[(][^;]*;[^;]*;\\s*AOL[^;]*;([^;\\)]*).*",
	"[\\s]*Opera[/ ][0-9a-zA-Z.]*\\s[(]Macintosh;([^;\\)]*).*",
	"[\\s]*Opera[/ ][0-9a-zA-Z.]*\\s[(]X11;([^;\\)]*).*",
	"[\\s]*Opera[/ ][0-9a-zA-Z.]*\\s[(]([^;\\)]*).*",
	"[\\s]*Mozilla[/ ][0-9a-zA-Z.]*\\s[(]([^;]*);[^;]*;[\\s]Trident[^;)]*.*",
	"[\\s]*Mozilla[/ ][0-9a-zA-Z.]*\\s[(][^;]*;[ U;]*;[ ]([^;\\)]*).*",
	"[\\s]*Mozilla[/ ][0-9a-zA-Z.]*\\s[(]compatible; MSIE \\d*.\\d*;\\s*([^;\\)]*).*",
	"[\\s]*\\w+[/ ][0-9a-zA-Z.]*\\s[(]\\w+;\\s*([^;\\)]*).*",
	"[\\s]*Mozilla[/ ][0-9a-zA-Z.]*\\s[(]([^;\\)]*).*"
];

/** @private @type {boolean} */
com.inq.utils.Capabilities._init = com.inq.utils.Capabilities.init();

/** @private @type {string} */
com.inq.utils.Capabilities.deviceType = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities.mobile = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities.webKit = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities.viewportDetectorInitialized = false;

/** @private @type {?string} */
com.inq.utils.Capabilities._iPhoneModel = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isVersionPrior8 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isVersion8 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isVersion9 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS8 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS10 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS11 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS12 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS13 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS14 = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isVersion14orLater = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isCriOS = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isSafari = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isIOSWebView = null;

/** @private @type {boolean} */
com.inq.utils.Capabilities._isAndroidWebView = null;

/** @private @type {int} */
com.inq.utils.Capabilities._origViewPortHeight = 0;


